import styled from '@mui/material/styles/styled';
import List from '@mui/material/List';

export const Root = styled('div')(({ theme }) => ({
  flexShrink: 0,
  width: 300,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: '#fff',
  ...theme.scrollbars.paper
}));
export const StyledList = styled(List)(({ theme }) => ({
  flexGrow: 1,
  overflowY: 'auto',
  ...theme.scrollbars.paper,
}));